import React from "react"

import { AppCardTitle, AppCrudTable } from "@components"
import { userSettingProvidersData } from "../../../@signals"
import { actionsColumn, colorColumn, nameColumn } from "./columns"
import { isTourDemoActive } from "@signals/app"
import UserSettingsProvidersTabButton from "../Button"

export default function UserSettingsColorProvidersTable() {
	if (isTourDemoActive.value && !userSettingProvidersData.value?.length) return null
	return <AppCrudTable
		// The tab's create button with the table's own actions, as every list of the app
		options={{ customToolbar: () => <UserSettingsProvidersTabButton/> }}
		title={<AppCardTitle icon="palette" title="Provider Colors"/>}
		data={userSettingProvidersData.value}
		columns={[
			nameColumn(),
			colorColumn(),
			actionsColumn()
		]}
	/>
}